import { Basket } from "./models";

export const basketSum = (basket: Basket) => basket.products.map(x => x.count * x.smartPointsPrice).reduce((p, c) => p + c, 0);

export const productCount = (productid: string, basket: Basket) => basket.products.find(p => p.id === productid)?.count ?? 0;